import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import { FirstChild } from 'utils/transitions';

import { TRANSITION } from 'theme';

const propTypes = {
    isOpened: PropTypes.bool.isRequired,
    transitionEnterTimeout: PropTypes.number,
    transitionLeaveTimeout: PropTypes.number,
};

const defaultProps = {
    isOpened: false,
    transitionEnterTimeout: parseInt(TRANSITION.LENGTH_LONG, 10),
    transitionLeaveTimeout: parseInt(TRANSITION.LENGTH_LONG, 10),
};

const StyledCollapseContent = styled.div`
    &.collapse {
        /* Need the transition on the active classes to animate with react-select */
        &-enter-active,
        &-leave-active {
            transform: translateZ(0);
            transition: all ${TRANSITION.LENGTH_LONG} ${TRANSITION.BEZIER};
        }

        /* Active must come after its previous state */
        &-enter {
            overflow: hidden;
        }

        &-leave {
            overflow: hidden;
        }
    }
`;

class CollapseContent extends React.Component {
    componentWillEnter(callback) {
        const el = ReactDOM.findDOMNode(this.collapseContent); // eslint-disable-line react/no-find-dom-node
        const height = el.offsetHeight;

        el.setAttribute('style', 'height: 0');
        el.classList.add('collapse-enter');
        setTimeout(() => {
            el.classList.add('collapse-enter-active');
            el.setAttribute('style', `height: ${height}px`);
        }, 0);

        setTimeout(callback, this.props.transitionEnterTimeout);
    }

    componentDidEnter() {
        const el = ReactDOM.findDOMNode(this.collapseContent); // eslint-disable-line react/no-find-dom-node

        // IE 10,11 does not support multiple parameters for remove
        el.classList.remove('collapse-enter-active');
        el.classList.remove('collapse-enter');

        el.removeAttribute('style');
    }

    componentWillLeave(callback) {
        const el = ReactDOM.findDOMNode(this.collapseContent); // eslint-disable-line react/no-find-dom-node

        el.setAttribute('style', `height: ${el.offsetHeight}px`);
        el.classList.add('collapse-leave');
        setTimeout(() => {
            el.classList.add('collapse-leave-active');
            el.setAttribute('style', 'height: 0');
        }, 0);

        setTimeout(callback, this.props.transitionEnterTimeout);
    }

    componentDidLeave() {
        const el = ReactDOM.findDOMNode(this.collapseContent); // eslint-disable-line react/no-find-dom-node

        // IE 10,11 does not support multiple parameters for remove
        el.classList.remove('collapse-leave-active');
        el.classList.remove('collapse-leave');

        el.removeAttribute('style');
    }

    render() {
        const { transitionEnterTimeout, transitionLeaveTimeout, children, ...props } = this.props;
        return (
            <StyledCollapseContent
                ref={(el) => {
                    this.collapseContent = el;
                }}
                {...props}
            >
                {children}
            </StyledCollapseContent>
        );
    }
}

const Collapse = ({ isOpened, children, ...props }) => {
    return (
        <TransitionGroup component={FirstChild}>
            {isOpened && <CollapseContent {...props}>{children}</CollapseContent>}
        </TransitionGroup>
    );
};

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;

export default Collapse;
